import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Action } from "../../internal/Action.js";
import { Qualifier } from "../../internal/qualifier/Qualifier.js";
import { tiled as _tiled } from "../flag.js";
import { noOverflow } from "../flag.js";
import { createGravityModel } from "../../internal/models/createGravityModel.js";
/**
 * @description
 * Defines the position of a layer: overlay or underlay.</br>
 * Even though Position is technically an action qualifier, it implements exactly the same functionality as an action.</br>
 * This is true because Position is compounded of multiple qualifiers</br>
 *
 * <b>Learn more:</b> {@link https://cloudinary.com/documentation/image_transformations#image_and_text_overlays|Applying overlays to images} | {@link https://cloudinary.com/documentation/video_manipulation_and_delivery#adding_image_overlays|Applying overlays to videos}
 *
 * @extends {SDK.Actions}
 */

var PositionQualifier = /*#__PURE__*/function (_Action) {
  _inherits(PositionQualifier, _Action);

  var _super = _createSuper(PositionQualifier);

  function PositionQualifier() {
    var _this;

    _classCallCheck(this, PositionQualifier);

    _this = _super.call(this);
    _this._actionModel = {};
    return _this;
  }

  _createClass(PositionQualifier, [{
    key: "gravity",
    value: function gravity(gravityQualifier) {
      this.addQualifier(gravityQualifier);
      this._actionModel.gravity = createGravityModel(gravityQualifier);
      return this;
    }
    /**
     * @description Tiles the overlay across your image.
     * <b>Learn more:</b> {@link https://cloudinary.com/documentation/image_transformations#tiling_overlays|Tiling overlay}
     */

  }, {
    key: "tiled",
    value: function tiled() {
      this.addFlag(_tiled());
      this._actionModel.tiled = true;
      return this;
    }
    /**
     * TODO - This should accept a boolean value
     * @description Prevents an image or text overlay from extending a delivered image canvas beyond the dimensions of the base image
     * <b>Learn more:</b> {@link https://cloudinary.com/documentation/transformation_reference#fl_no_overflow|Overflow in overlays}
     */

  }, {
    key: "allowOverflow",
    value: function allowOverflow() {
      var bool = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (bool === false) {
        this.addFlag(noOverflow());
      }

      this._actionModel.allowOverflow = bool;
      return this;
    }
    /**
     * @description Set the X Offset
     * @param {number | string} offsetX
     * @return {this}
     */

  }, {
    key: "offsetX",
    value: function offsetX(_offsetX) {
      this.addQualifier(new Qualifier('x', _offsetX));
      this._actionModel.offsetX = _offsetX;
      return this;
    }
    /**
     * @description Set the Y Offset
     * @param {number | string} offsetY
     * @return {this}
     */

  }, {
    key: "offsetY",
    value: function offsetY(_offsetY) {
      this.addQualifier(new Qualifier('y', _offsetY));
      this._actionModel.offsetY = _offsetY;
      return this;
    }
  }]);

  return PositionQualifier;
}(Action);

export { PositionQualifier };